import * as React from 'react';
import { Label } from '../Label';
import { Toggle } from '../Toggle';
import type { ToggleWithLabelProps } from './types';

function ToggleWithLabel({ label, className, ...props }: ToggleWithLabelProps) {
  const id = React.useId();

  return (
    <div
      className={`eye:inline-flex eye:items-center eye:gap-2xs ${className}`}
    >
      <Toggle id={id} {...props} />
      <Label htmlFor={id}>{label}</Label>
    </div>
  );
}

export { ToggleWithLabel };
